/* Progressive enhancement: keeps Dawn's radio inputs, variant IDs and change events. */
if (!customElements.get('zp-uv-fit')) {
  customElements.define('zp-uv-fit', class extends HTMLElement {
    connectedCallback() {
      this.observer = new MutationObserver(() => this.enhance());
      this.observer.observe(this, {childList: true, subtree: true});
      this.enhance();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    group(value) {
      const v = value.toLocaleLowerCase('es');
      return v.includes('bulldog') ? 'Bulldog inglés' : v.includes('largo') ? 'Especial largo' : 'Estándar';
    }
    size(value) { return value.split('(')[0].trim().toUpperCase(); }
    enhance() {
      const fields = this.querySelectorAll('fieldset');
      if (fields.length !== 1) return;
      const field = fields[0];
      if (field.dataset.zpEnhanced) return;
      const inputs = [...field.querySelectorAll('input[type="radio"]')];
      if (!inputs.length || !/talla|size|tamaño/i.test(inputs[0].dataset.optionName || '')) return;
      field.dataset.zpEnhanced = 'true';
      const groups = [...new Set(inputs.map(i => this.group(i.value)))];
      const current = inputs.find(i => i.checked) || inputs[0];
      const legend = field.querySelector('legend');
      const wrapper = document.createElement('div');
      wrapper.className = 'zp-fit-controls';
      const buttons = [];
      if (groups.length > 1) {
        const heading = document.createElement('p');
        heading.className = 'zp-fit-label'; heading.textContent = '1. Elige el calce';
        wrapper.append(heading);
        const row = document.createElement('div'); row.className = 'zp-fit-buttons';
        row.setAttribute('role', 'group'); row.setAttribute('aria-label', 'Tipo de calce');
        ['Estándar','Especial largo','Bulldog inglés'].filter(g => groups.includes(g)).forEach(group => {
          const button = document.createElement('button');
          button.type = 'button'; button.textContent = group; button.dataset.fit = group;
          button.addEventListener('click', () => {
            const checked = inputs.find(i => i.checked);
            const candidates = inputs.filter(i => this.group(i.value) === group);
            const available = candidates.filter(i => !i.disabled && !i.classList.contains('disabled'));
            const match = available.find(i => this.size(i.value) === this.size(checked?.value || '')) || available[0] || candidates[0];
            if (match) {
              apply(group);
              if (!match.checked) match.click();
            }
          });
          buttons.push(button); row.append(button);
        });
        wrapper.append(row);
        const hint = document.createElement('p'); hint.className='zp-fit-hint';
        hint.dataset.fitHint=''; wrapper.append(hint);
        field.before(wrapper);
      }
      inputs.forEach(input => {
        const label = field.querySelector(`label[for="${CSS.escape(input.id)}"]`);
        if (label) {
          label.setAttribute('aria-label', input.value);
          [...label.childNodes].filter(n => n.nodeType === Node.TEXT_NODE).forEach(n => n.remove());
          label.prepend(document.createTextNode(this.size(input.value)));
        }
      });
      const apply = group => {
        buttons.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.fit === group)));
        const hint = wrapper.querySelector('[data-fit-hint]');
        if (hint) hint.textContent = {'Estándar':'Nuestro calce regular. Revisa las medidas antes de elegir.','Especial largo':'Para quienes necesitan más largo de espalda.','Bulldog inglés':'Calce especial para bulldog inglés.'}[group];
        inputs.forEach(i => {
          const hidden = this.group(i.value) !== group;
          i.hidden = hidden; i.tabIndex = hidden ? -1 : 0;
          const label = field.querySelector(`label[for="${CSS.escape(i.id)}"]`);
          if (label) label.hidden = hidden;
        });
        if (legend) legend.textContent = (groups.length > 1 ? '2. Elige la talla' : 'Elige la talla');
      };
      field.addEventListener('change', e => {
        if (inputs.includes(e.target)) apply(this.group(e.target.value));
      });
      apply(this.group(current.value));
    }
  });
}
